// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__e_BJg","truncatedText":"styles_truncatedText__ffqwb","fullText":"styles_fullText__wJjMr","textContainer":"styles_textContainer__xwc4M"};